import React, { useState } from 'react';
import { GET_MANY, UPDATE } from 'ra-core';
import { useDataProvider, useTranslate, downloadCSV, Button as AdminButton, useRefresh } from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import PublishIcon from '@mui/icons-material/Publish';
import { DropzoneDialog } from 'react-mui-dropzone';
import ResultDialog from '../../../Utilities/ResultDialog';
import { unparse as convertToCSV, parse } from 'papaparse/papaparse.min';
var authProvider = require('../../../authProvider');

function UploadFileButton() {
    const [open, setOpen] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);

    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const refresh = useRefresh();

    const handleClose = () => {
        setOpen(false);
    }

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogRows([]);
        setResultDialogHeaders([]);
        setResultLoading(false);
    }

    const handleSave = async (files) => {
        var startTime = new Date();
        setResultDialogOpen(false);
        setResultDialogOpen(true);
        setResultLoading(true);

        const expectedFormat = "serial_number_tim,cod_terr_sap,note";
        const separatorsPerRow = expectedFormat.split(",").length - 1;

        //Saving files to state for further use and closing Modal.
        var text = await (new Response(files[0])).text();
        if (text.indexOf(expectedFormat) === 0) {
            let validRow = true;
            let lineBreak = text.indexOf("\r\n") > -1 ? "\r\n" : text.indexOf("\r") > -1 ? "\r" : "\n";
            let rows = text.split(lineBreak);
            let tempText = "";
            rows.forEach(row => {
                if (row !== "") {
                    let t = 0;
                    let cleanRowText = row.replace(/,/g, match => ++t > 2 ? ' ' : match);
                    tempText = tempText + cleanRowText + lineBreak;
                    //make sure that in each rows we have the expected number of columns
                    if (cleanRowText.split(",").length - 1 !== separatorsPerRow) {
                        validRow = false;
                    }
                }
            });
            text = tempText;

            if (!validRow) {
                setResultDialogOpen(true);
                setResultDialogRows([["Il file non è nel formato previsto. " + expectedFormat]]);
                setResultDialogHeaders(["File Status"]);
                setResultLoading(false);
            }
            else {

                var output = await parse(text.toString(), {
                    delimiter: ',',
                    header: true,
                    skipEmptyLines: true
                }).data;

                var { validIds, invalidSerialNum, invalidAOA } = await getSerials(output);
                var resultArray = [];
                if (validIds.length > 0) {
                    var user = localStorage.getItem('username');

                    for (let i = 0; i < validIds.length; i++) {
                        let item = validIds[i];
                        let updateProps = {
                            id: item.id,
                            data: { status: { codice: '4' }, approved_at: new Date(), approved_by: user }
                        };

                        let note = output.find(o => o.serial_number_tim === item.serial_number_tim)?.note;

                        if (note) {
                            updateProps.data.note = note.replace(/[^a-zA-Z0-9 ]/g, '');
                            updateProps.data.note = item.original_note ? item.original_note + " " + updateProps.data.note : updateProps.data.note;
                        }

                        let response = await dataProvider(UPDATE, 'devices', updateProps)
                            .catch(error => {
                                console.log(error);
                            });

                        if (response.data && response.data.message === "Updated") {
                            resultArray.push([response.data.doc.serial_number_tim, response.data.doc.status.descrizione, <DoneIcon />, ""]);
                        }
                    }
                    refresh();
                }
                if (invalidSerialNum) {
                    invalidSerialNum.map(serialNum => {
                        resultArray.push([serialNum, '', <ErrorIcon />, translate('tim.uploadfile.invalidStatus')])
                    })
                };
                if (invalidAOA) {
                    invalidAOA.map(serialNum => {
                        resultArray.push([serialNum, '', <ErrorIcon />, translate('tim.uploadfile.invalidAOA')])
                    })
                };

                setResultDialogOpen(true);
                setResultDialogRows(resultArray);
                setResultDialogHeaders(["Apparato", "Stato", "Risultato", "Dettaglio"]);
                setResultLoading(false);
            }
        }
        else {
            setResultDialogOpen(true);
            setResultDialogRows([["Il file non è nel formato previsto. " + expectedFormat]]);
            setResultDialogHeaders(["File Status"]);
            setResultLoading(false);
        }

        var endTime = new Date();
        console.log(timeElpased(startTime, endTime));
    }

    const handleOpen = () => {
        setOpen(true);
    }

    const exportToCSV = () => {
        const resultForExport = this.state.resultDialogRows.map(row => {
            const { ...resultForExport } = {};
            resultForExport.Apparato = row[0];
            resultForExport.Stato = row[1];
            resultForExport.Risultato = row[3] === "" ? "OK" : "KO";
            resultForExport.Errore = row[3];
            return resultForExport;
        })
        const csv = convertToCSV({
            data: resultForExport,
            fields: this.state.resultDialogHeaders
        });
        downloadCSV(csv, 'Risultati');
    }

    const getSerials = async (output) => {
        var validIds = [];
        var validSerialNum = [];
        var invalidAOA = [];
        var invalidSerialNum = [];
        var serialNums = getArrayByProperty(output, 'serial_number_tim');
        var chunkedOutput = chunkOuput(serialNums, 10);
        let user_data = authProvider.getData().data;
        let magazini = user_data.aoa;
        let area = getArea(magazini);
        if (magazini) {
    
            for (let index = 0; index < chunkedOutput.length; index++) {
                var validDevices = await dataProvider(GET_MANY, 'devices', {
                    "filter": { "status": { "codice": "3" }, "serial_number_tim": { $in: chunkedOutput[index] } }
                })
                    .then(
                        response => {
                            if (response.total > 0)
                                return response.data;
                            else
                                return undefined;
                        })
                    .catch(error => {
                        console.log(error);
                    });
                var invalidAOADevices = await dataProvider(GET_MANY, 'devices', {
                    "filter": { "status": { "codice": "3" }, "area": { $ne_up: area }, "serial_number_tim": { $in: chunkedOutput[index] } }
                })
                    .then(
                        response => {
                            if (response.total > 0)
                                return response.data;
                            else
                                return undefined;
                        })
                    .catch(error => {
                        console.log(error);
                    });
                if (validDevices) {
                    validDevices.forEach(device => {
                        validIds.push({ id: device.id, serial_number_tim: device.serial_number_tim, original_note: device.note });
                        if (!validSerialNum.includes(device.serial_number_tim)) {
                            validSerialNum.push(device.serial_number_tim)
                        }
                    });
                }
                if (invalidAOADevices) {
                    invalidAOADevices.forEach(iAOAdevice => {
                        invalidAOA.push(iAOAdevice.serial_number_tim);
                    });
                }
            }
            let invalidSerialNum = serialNums.filter(x => !validSerialNum.includes(x) && !invalidAOA.includes(x));
            return { validIds, invalidSerialNum, invalidAOA };
        }
        else return { validIds, output };
    
    }
    
    const timeElpased = (starTime, endTime) => {
        var timeDiff = endTime - starTime;
        timeDiff /= 1000;
        var seconds = Math.round(timeDiff);
        return seconds;
    }
    
    const chunkOuput = (output, chunk_size) => {
        var tempOutput = output.slice();
        var results = [];
        while (tempOutput.length) {
            results.push(tempOutput.splice(0, chunk_size));
        }
    
        return results;
    }
    
    const getArrayByProperty = (array, property) => {
        var propertyArray = []
        array.forEach(item => {
            propertyArray.push(item[property])
        });
        return propertyArray;
    }
    
    const getArea = (magazini) => {
        const mapping = {
            "IMNO": "AOA.NO",
            "IMNE": "AOA.NE",
            "IMSU": "AOA.SUD",
            "IMCN": "AOA.CE"
        };
    
        return magazini
            .split(", ")
            .map(mag => mapping[mag] || "")
            .filter(area => area)
            .join(", ");
    };

    return (
        <div>
            <AdminButton label='Upload File Approvazione' onClick={handleOpen.bind(this)} >
                <PublishIcon />
            </AdminButton>
            <DropzoneDialog
                open={open}
                onSave={handleSave.bind(this)}
                acceptedFiles={['application/vnd.ms-excel', 'text/csv']}
                dropzoneText={'Trascina e rilascia qui un file CSV nel formato serial_number_tim,cod_terr_sap,note'}
                filesLimit={1}
                showPreviews={true}
                maxFileSize={5000000}
                onClose={handleClose.bind(this)}
            />
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title="Risultati"
                onClose={handleResultClose}>
                {!resultLoading && <AdminButton label='tim.uploadfile.export' onClick={exportToCSV} color="primary"></AdminButton>}
                {!resultLoading && <AdminButton label='tim.uploadfile.close' onClick={handleResultClose.bind(this)} color="primary"></AdminButton>}
            </ResultDialog>
        </div>
    );
}

export default UploadFileButton;